<template>
  <v-text-field
    v-bind="$attrs"
    :density="xs ? 'compact' : 'default'"
    class="onboarding-field"
    variant="outlined"
    color="primary"
    hide-details="auto"
  >
    <template #message="{ message }">
      <span class="d-inline-flex align-center ga-1">
        <v-icon
          icon="mdi-alert-circle-outline"
          size="16"
        />
        {{ message }}
      </span>
    </template>
  </v-text-field>
</template>

<script setup lang="ts">
import { useDisplay } from 'vuetify'
const { xs } = useDisplay()
defineOptions({ inheritAttrs: false })
</script>

<style scoped>
.onboarding-field :deep(.v-field__prepend-inner .v-icon) {
  color: rgb(var(--v-theme-rain-forest, var(--v-theme-primary)));
  opacity: 1;
}
.onboarding-field.v-input--error :deep(.v-field__prepend-inner .v-icon) {
  color: rgb(var(--v-theme-error));
}
</style>
